import React from 'react';

import ButtonBase from './ButtonBase';

const buttonBaseIcon = (props) => {
    const { icon, ...otherProps } = props;
    return (
        <ButtonBase {...otherProps}>{icon}</ButtonBase>
    );
}

export default buttonBaseIcon;